import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import Small from 'UIComponents/elements/Small';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import CertificateButtonWrapper, { CertificateButtonIconContainer, CertificateButtonInnerRightButton } from './CertificateButtonWrapper';
import { FormattedMessage, FormattedReactMessage, FormattedDateTime } from 'LearningCenterUI/components/I18n';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { EERIE } from 'HubStyleTokens/colors';
import styled from 'styled-components';
const PositionedUIIcon = styled(UIIcon).withConfig({
  displayName: "CertificateButtonCompleted__PositionedUIIcon",
  componentId: "sc-19d0vuc-0"
})(["position:relative;top:2px;"]);
const MONTH = 2629800000;

const CertificateButtonCompleted = ({
  awardName,
  name,
  trackId,
  onClick,
  expiresAt,
  isSelected
}) => {
  const history = useHistory();
  const {
    url
  } = useRouteMatch();
  const {
    search
  } = useLocation(); // expiresAt will have value 0 for awards which never expire

  const isExpiringSoon = expiresAt === 0 ? false : expiresAt - MONTH < +Date.now();
  return /*#__PURE__*/_jsxs(CertificateButtonWrapper, {
    isSelected: isSelected,
    iscompleted: 1,
    onClick: onClick,
    children: [/*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      className: "p-right-4",
      direction: "column",
      children: [name, /*#__PURE__*/_jsx(Small, {
        use: "help",
        weight: "regular",
        children: isExpiringSoon ? /*#__PURE__*/_jsx(FormattedReactMessage, {
          className: "cert-button-subtext",
          message: "learningCenter.mostPopularCertificates.expiring",
          options: {
            date: /*#__PURE__*/_jsx(FormattedDateTime, {
              format: "L",
              value: expiresAt
            })
          }
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          className: "cert-button-subtext",
          message: "learningCenter.mostPopularCertificates.completed"
        })
      })]
    }), /*#__PURE__*/_jsx(CertificateButtonInnerRightButton // @ts-expect-error Untyped
    , {
      direction: "column",
      onClick: e => {
        e.stopPropagation();
        const noTrailingUrl = url.length > 0 && url[url.length - 1] === '/' ? url.replace(/\/$/, '') : url;
        const link = `${noTrailingUrl}/award/${trackId}/${awardName}${search}`;
        history.push(link);
      },
      children: /*#__PURE__*/_jsx(CertificateButtonIconContainer, {
        children: /*#__PURE__*/_jsx(PositionedUIIcon, {
          color: EERIE,
          name: "share",
          size: 24
        })
      })
    })]
  });
};

export default CertificateButtonCompleted;